import Swiper from 'swiper/bundle';

import '../page/event/index';
import '../block/animation';
import '../block/sliderCursor';
import options from '../block/swiperOptions';
import './attendee/items';
import educationItems from './../page/education/items';
import supportHtml from './../page/support/html';
import FixedElement from '../../../../../js-modules/FixedElement';
import './live-past';

class Index {
    constructor() {
        this.events();

        let LiveFixedElem = new FixedElement('.fixed-telegram');
        LiveFixedElem.onOverSection('[section-dark]', isOverSection => {
            if (isOverSection) {
                $('[fixed-live]').addClass('fixed-live-dark');
                $('[fixed-telegram]').addClass('fixed-telegram-dark');
            } else {
                $('[fixed-live]').removeClass('fixed-live-dark');
                $('[fixed-telegram]').removeClass('fixed-telegram-dark');
            }
        });

        let cookie_accepts = document.querySelectorAll('[data-cookie-accept]');
        if (cookie_accepts) {
            $('[data-cookie-accept]').on('click', () => {
                $('[fixed-live]').removeClass('fixed-live-up');
                $('[fixed-telegram]').removeClass('fixed-telegram-up');
                $('[fixed-vk]').removeClass('fixed-vk-up');
            });
        }
    }

    events() {
        this.swipers();
        this.support();

        educationItems({
            first_load: true
        });

        this.liveFixed();
        $(window).on('resize', () => {
            this.liveFixed();
        });

        this.telegramFixed();
        $(window).on('resize', () => {
            this.telegramFixed();
        });

        items.create({
            name: 'lesson-video',
            modal: {
                data: (id, callback) => {
                    callback(JSON.parse($('[data-lesson-' + id + ']').attr('data-lesson-' + id + '')));
                }
            }
        });

        $(document).on('click', '[data-lessons-more]', function () {
            $(this).hide();
            $('[items-html-lesson-video]').show();
        });
    }

    support() {
        items.create({
            name: 'support',
            first_load: true,
            html: supportHtml
        });
    }

    swipers() {

        // Темы
        ZoneObject.create('.section-themes', {
            run: () => {
                // Темы
                new Swiper('.swiper-1', $.extend(options, {
                    slidesPerView: 'auto',
                    spaceBetween: 20
                }));
            }
        });

        // Совет
        ZoneObject.create('.section-direction', {
            run: () => {
                // Совет
                new Swiper('.swiper-3', $.extend(options, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            spaceBetween: 20
                        }
                    }
                }));
            }
        });

        // Карточки доков
        ZoneObject.create('.section-docs', {
            run: () => {
                // Карточки файлов
                new Swiper('.swiper-docs', $.extend(options, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            spaceBetween: 20
                        }
                    }
                }));
            }
        });

        // Карточки партнеров
        ZoneObject.create('.section-partner', {
            run: () => {
                // Карточки партнеров
                new Swiper('.swiper-partner', $.extend(options, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            spaceBetween: 20
                        }
                    }
                }));
            }
        });
    }

    liveFixed() {
        $('[fixed-live]').css('right', $('.container').offset().left + 15);
    }

    telegramFixed() {
        $('[fixed-telegram]').css('right', $('.container').offset().left + 15);
    }

}

new Index();